import { Component, Input, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-cycle-progress-chart',
  templateUrl: './progress-chart.component.html',
  styleUrls: ['./progress-chart.component.scss']
})
export class CycleProgressChartComponent {

  public isbrowser: boolean = true;

  @Input() current: number = 0;
  @Input() total: number = 0;
  @Input() isLoadingSteps: boolean = false;

  @Input() readonly enviromentPercentage = 100;

  constructor(
    @Inject(PLATFORM_ID) _platformId
  ) {
    this.isbrowser = isPlatformBrowser(_platformId);
  }

  public getCompletedCircle(): string {
    const progress = (this.current / this.total) * 100;
    return (progress + ',100').toString();
  }

}
